import { Card } from '../../components/home/card';
import { useTranslation } from 'react-i18next';

export function RefundPolicyRoute() {
    const { t } = useTranslation();

    return (
        <div className="mx-auto w-full max-w-3xl">
            <Card className="animate-fade-up">
                <header className="space-y-3">
                    <p className="text-xs font-semibold uppercase tracking-[0.35em] text-secondary">{t('route.refund.txtEyebrow')}</p>
                    <h1 className="text-3xl font-semibold leading-tight text-foreground md:text-4xl">{t('route.refund.txtTitle')}</h1>
                    <p className="text-xs text-secondary">
                        {t('route.refund.txtLastUpdatedLabel')}:{' '}
                        <span className="font-semibold text-foreground/80">{t('route.refund.txtLastUpdatedDate')}</span>
                    </p>
                </header>

                <div className="mt-6 space-y-6 text-sm leading-relaxed text-secondary">
                    <p>
                        {t('route.refund.txtIntro')}
                    </p>

                    <section className="space-y-2">
                        <h2 className="text-base font-semibold tracking-tight text-foreground">
                            {t('route.refund.txtSectionServiceErrorsTitle')}
                        </h2>
                        <p>
                            {t('route.refund.txtSectionServiceErrorsBody')}
                        </p>
                        <ul className="list-disc space-y-2 pl-5">
                            <li>{t('route.refund.txtServiceErrorsItemJobFailed')}</li>
                            <li>{t('route.refund.txtServiceErrorsItemDeliveryFailed')}</li>
                        </ul>
                    </section>

                    <section className="space-y-2">
                        <h2 className="text-base font-semibold tracking-tight text-foreground">{t('route.refund.txtSectionHelpTitle')}</h2>
                        <p>
                            {t('route.refund.txtSectionHelpBody')}
                        </p>
                        <p>{t('route.refund.txtNoRefundsNote')}</p>
                    </section>
                </div>
            </Card>
        </div>
    );
}
